var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-bg"},[_c('div',{staticClass:"inner-content"},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"src":require("../../assets/logo.png"),"alt":""}})]),_c('p',[_vm._v(" WIF helps you communicate with your teammates, track events, keep schedules, team organization and much more. ")])])])
}]

export { render, staticRenderFns }